import bg from "../assets/background.png";
export const Noise = () => {
  return (
    <>
      <div className="fixed inset-0 -z-10 h-[100vh]  flex-none">
        <div
          style={{ backgroundSize: "128px", backgroundImage: `url(${bg})` }}
          className={`h-full min-h-full bg-repeat opacity-[0.08]`}
        ></div>
      </div>
    </>
  );
};
